export const chapters = [
  {
    id: 'hero',
    nav: 'MoLiKa 9bar',
    theme: 'dark',
    align: 'left',
    position: [3.15, 0.42, 4.45],
    target: [0, 0.04, 0],
    modelPosition: [0.52, -0.04, 0],
    modelRotation: [0.02, -0.34, 0],
    explode: 0,
    transparency: 0,
    accent: '#d9ff43',
  },
  {
    id: 'system',
    nav: '系统总览',
    theme: 'light',
    align: 'right',
    position: [-3.15, 0.38, 4.0],
    target: [0, -0.08, 0],
    modelPosition: [-0.48, -0.02, 0],
    modelRotation: [0.02, 0.42, 0],
    explode: 0.12,
    transparency: 0.04,
    accent: '#ff6047',
  },
  {
    id: 'pressure',
    nav: '压力锅炉',
    theme: 'dark',
    align: 'left',
    position: [2.3, -1.08, 2.66],
    target: [0, -0.72, 0],
    modelPosition: [0.44, 0, 0],
    modelRotation: [0.02, -0.5, 0],
    explode: 0,
    transparency: 0.2,
    accent: '#ff6047',
    focus: 'high-pressure-boiler',
  },
  {
    id: 'thermal',
    nav: '双级换热',
    theme: 'light',
    align: 'right',
    position: [-2.58, -0.12, 3.02],
    target: [0, -0.12, 0],
    modelPosition: [-0.72, 0, 0],
    modelRotation: [0.01, 0.54, 0],
    explode: 0.18,
    transparency: 0.34,
    accent: '#24b7d5',
    focus: 'coil-heat-exchanger',
  },
  {
    id: 'valve',
    nav: '机械阀门',
    theme: 'dark',
    align: 'left',
    position: [1.78, -0.44, 1.88],
    target: [0, -0.34, 0.1],
    modelPosition: [0.52, 0, 0],
    modelRotation: [0.02, -0.18, 0],
    explode: 0.3,
    transparency: 0.46,
    accent: '#d9ff43',
    focus: 'spring-loaded-valve',
  },
  {
    id: 'brew',
    nav: '向上萃取',
    theme: 'light',
    align: 'right',
    position: [2.2, 1.06, 2.6],
    target: [0, 0.72, 0],
    modelPosition: [-0.5, -0.02, 0],
    modelRotation: [0.02, -0.48, 0],
    explode: 0.1,
    transparency: 0.2,
    accent: '#ff6047',
    focus: 'ground-coffee-basket',
  },
  {
    id: 'exploded',
    nav: '结构分解',
    theme: 'dark',
    align: 'left',
    position: [4.35, 0.22, 5.55],
    target: [0, 0.13, 0],
    modelPosition: [0.42, 0, 0],
    modelRotation: [0.02, -0.6, 0],
    explode: 1,
    transparency: 0,
    accent: '#24b7d5',
  },
  {
    id: 'cutaway',
    nav: '内部剖面',
    theme: 'paper',
    align: 'left',
    position: [3.0, 0.26, 4.3],
    target: [0, 0.05, 0],
    modelPosition: [0.42, 0, 0],
    modelRotation: [0.02, -0.18, 0],
    explode: 0,
    transparency: 0.7,
    accent: '#ff6047',
    hideModel: 1,
  },
  {
    id: 'explore',
    nav: '自由查看',
    theme: 'dark',
    align: 'center',
    position: [3.25, 0.38, 4.3],
    target: [0, 0.04, 0],
    modelPosition: [0, -0.02, 0],
    modelRotation: [0.02, -0.34, 0],
    explode: 0,
    transparency: 0,
    accent: '#d9ff43',
  },
  {
    id: 'gallery',
    nav: '设计细节',
    theme: 'paper',
    align: 'left',
    position: [3.25, 0.38, 4.3],
    target: [0, 0.04, 0],
    modelPosition: [0, -0.02, 0],
    modelRotation: [0.02, -0.34, 0],
    explode: 0,
    transparency: 0,
    accent: '#ff6047',
    hideModel: 1,
  },
]

export const explodedLabels = [
  ['01', '浓缩咖啡承接杯'],
  ['02', '咖啡粉篮与萃取腔'],
  ['03', '鳍片式空气换热器'],
  ['04', '弹簧加载机械阀'],
  ['05', '盘管式液体换热器'],
  ['06', '高压锅炉'],
]
